/* src/util/dates.js */

import moment from 'moment';
import { reduce } from 'lodash';

import { zeroPad } from './numbers';

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
  'Oct', 'Nov', 'Dec'];

export const formatDate = date => {
  const d = new Date(date);
  return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
};

/**
 * Given a list of objects with a date attribute, returns a list sorted by
 * the date attribute in chronological order.
 *
 * @param {Object[]} dates - list of objects with date attribute
 * @param {Object} dates[].date - date attribute
 * @returns {Object[]} list sorted by date in chronological order
 *
 */
export const sortDates = dates =>
  dates.map(d => ({ ...d, date: new Date(d.date) }))
    .sort((a, b) => a.date - b.date);

export const getTimestamp = ({ month, day, year, hour = 0, min = 0 }) => {
  // console.log(year, month, day, hour, min, `${year}-${zeroPad(month + 1)}-${zeroPad(day)} ${zeroPad(hour)}:${zeroPad(min)}`)
  const d = moment(`${year}-${zeroPad(month + 1)}-${zeroPad(day)} ${zeroPad(hour)}:${zeroPad(min)}`);
  return `${d.valueOf()}`;
};

const momentHelper = timestamp => {
  let ts = 0;
  if (typeof timestamp === 'string') ts = parseInt(timestamp, 10);
  else ts = timestamp;
  return ts;
};

export const getMoment = timestamps => {
  let ts = 0;
  if (typeof timestamps === 'object')
    ts = reduce(timestamps, (acc, t) => acc + momentHelper(t), 0);
  else
    ts = momentHelper(timestamps);
  return moment(ts);
};



// WEBPACK FOOTER //
// ./src/util/dates.js